import { useEffect, useRef } from 'react';
import {onSQFTLoadPrepareData, onSQFTLoadImport} from "../../helpers/sqftHelperUi";
import store from "../../../../store";
import {SQFT_VIEW_MODE} from "../../constants";
import sqftEventManager from "../../components/canvas/store/sqftEventManager";
import workspace from "../../components/canvas/core/workspace";
import scale from "../../components/canvas/core/controls/scale";
import $ from "jquery";

const useImportSQFTData = (visualizersLoaded, SQFTViewMode) => {
  const importedVisualizersLoadedRef = useRef(null);

  useEffect (() => {
    if (importedVisualizersLoadedRef.current === visualizersLoaded) {
      return;
    }

    const state = store.getState()
    const {visualizerIsChanging} = state.serverState;
    const workspaceCanvas = document.getElementById("workspace");
    if (
      visualizersLoaded.length
      && !visualizerIsChanging
      && SQFTViewMode === SQFT_VIEW_MODE.twoDMode
      && workspaceCanvas
    ) {
      sqftEventManager.clearAll();
      workspace.init($('#workspace'));
      scale.init();

      const payload = onSQFTLoadPrepareData();
      onSQFTLoadImport(payload);
      importedVisualizersLoadedRef.current = visualizersLoaded;
    }

  }, [visualizersLoaded, SQFTViewMode]);
};

export default useImportSQFTData;
